import { api_react_v1_events_path } from '@routes';

import request from './request';

export const EVENT_LIST_KEY = 'EVENT_LIST_KEY';

export interface SanitizedEventParams {
  page: number;
}

export interface Event {
  additionalDayTimes?: string;
  canRegisterNow?: boolean;
  conferenceCall?: boolean;
  date: string;
  description?: string;
  endTime?: string;
  extraDays?: number;
  hideSponsorButton?: boolean;
  highlight: string;
  image: string;
  isCurrentUserAnnualSubscriber?: boolean;
  isCurrentUserProSubscriber?: boolean;
  isCurrentUserSubscriber?: boolean;
  isCurrentUserYPSubscriber?: boolean;
  isFeatured?: boolean;
  location: string;
  name: string;
  pictureUrl?: string;
  registrationHasPassed?: boolean;
  slug: string;
  startTime?: string;
  timeZone?: string;
  userHasRsvpd?: boolean;
}

export interface EventsResult {
  pastEvents: Event[];
  nextPage?: number;
}

export async function getEvents(parameters?: SanitizedEventParams): Promise<EventsResult> {
  const resp = await request('get', api_react_v1_events_path(parameters || {}));
  return resp;
}
